import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ReportControls, UIStore } from '../../../shared/types/appTypes';
import { GridFilterModel } from '@mui/x-data-grid';

// Initial state for the reportControls slice
const initialState: UIStore = {
  talentDialogState: null
};

// Create the reportControls slice
const uiStoreSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    // Set the talent dialog open state
    setTalentDialogOpen(state, action: PayloadAction<string | null>) {
      state.talentDialogState = action.payload;
    }
  }
});

export const { setTalentDialogOpen } = uiStoreSlice.actions;

export default uiStoreSlice.reducer;
